import { ConfirmationModal, PhoneVerification } from '@adc/ui-core'
import AuctionApplication from './auctionApplication/shell'
import ApplicationHeader from './auctionApplication/applicationHeader'
import FocusedAuctionApplication from './auctionApplication/shellFocused'
import { useApplicationModals } from './auctionApplication/modals'
import { useApplicationQueues } from './auctionApplication/queues'
import { useApplicationSurvey } from './auctionApplication/applicationSurvey'
import {
  useApplicationContext,
  withApplicationContext,
  ApplicationContext,
  ApplicationContextProvider,
} from './auctionApplication/context'
// TODO; remove this once we're sure all usages of old notifier are done away with
import * as notifiers from './auctionApplication/notifiers'
import { withNotifications } from './auctionApplication/applicationSessionInformation'
import AuthToggle, { AuthToggleModal } from './authToggle'
import LoginForm from './authToggle/components/login'
import SignupForm from './authToggle/components/signup'
import SMSOptInToggle from './smsOptInToggle'
import PostSaveOptInModal from './postSaveOptInModal'
import AdcHeader from './header'
import LogoHeader from './header/logoHeader'
import NativeAppBanner from './nativeAppBanner'
import CardTab from './cardTab'
import OnboardingDrawer from './onboardingDrawer'
import PageWrapper from './pageWrapper'
import * as CreditCard from './creditCard'
import AuctionApplicationProvider from './auctionApplicationProvider'
import { TabsDeprecated, PaneDeprecated } from './tabsDeprecated'
import QRCode from './qrCode'
import AdcSearch, { MAX_AMOUNT_OF_ADDRESS_RESULTS } from './search'
import NewUserOnboardingModals from './newUserOnboarding'
import ChatButton from './chatButton'
import ChatLink from './chatLink'
import SearchLocationInterestReduxWrapper from './authToggle/components/searchField'
import BudgetDropdownReduxWrapper from './authToggle/components/dropdownField'
import StripePaymentSetup from './stripePayment/paymentSetup'
import { ContractNotification } from './notificationTypes'
import {
  createTrusteePurchaseProfile,
  updateTrusteePurchaseProfile,
  TrusteePurchaseProfileFormFields,
  TRUSTEE_PURCHASE_PROFILE_FORM_NAME,
  TRUSTEE_PURCHASE_PROFILE_FORM_FRAGMENT,
  EntityForm,
  MultiCoBuyerForm,
  MULTI_CO_BUYER_FORM_NAME,
  EntityFormRules,
  InternationalCheckbox,
  NEW_ENTITY_FORM_NAME,
  RelationshipModal,
  matchRelationship,
  isMarriedBuyer,
  checkTwoMarriedPeople,
  getBuyerFullName,
  getBuyerId,
  findSpouse,
  getRelationship,
  generateRelationshipModalProps,
  updateMaritalStatus,
  buildRelationshipsMap,
  SPOUSE_ON_CONTRACT_NA,
  SOMEONE_ELSE,
  transformerEntityApiToFe,
  transformerEntityFeToApi,
  transformerCobuyerApiToFe,
  transformerCobuyerFeToApi,
  getMultiEntityFormFields,
  getMultiCobuyerFormFields,
} from './forms'
import Bars from './bars'
import TutorialTooltip, {
  TutorialTooltipGroupItem,
  TutorialTooltipActions,
  TutorialTooltipReducer,
} from './tutorialTooltip'
import Footer from './footer'
import OfferBadge from './offerBadge'
import Gauge from './gauge'
import LogoutButton from './logoutButton'
import VerificationModal from './verificationModal'
import ListingCarousel from './listingCarousel'
import {
  ListingCarouselEmbedded,
  ListingCarouselEmbeddedProps,
} from './listingCarouselEmbedded'
import ListingPhotoGrid from './listingPhotoGrid'
import { BidConfirmationContent } from './bidConfirmation'
import OfferAmountHeader from './offerAmountHeader'
import OfferSummaryHeader from './offerSummaryHeader'
import ListingInfoCard from './listingInfoCard'
import AcceptBidContent from './traditionalOfferActionsContent/acceptBidContent'
import DeclineBidContent from './traditionalOfferActionsContent/declineBidContent'
import { getAccessibilityScript } from './auctionApplicationProvider/getAccessiblityScript'

// I don't know where it's used but I'm afraid to
// break something so keeping PhoneInputField export
const { PhoneInputField } = PhoneVerification

export {
  AuctionApplicationProvider,
  getAccessibilityScript,
  AuthToggle,
  AuthToggleModal,
  LoginForm,
  SignupForm,
  BidConfirmationContent,
  ConfirmationModal,
  EntityForm,
  EntityFormRules,
  matchRelationship,
  isMarriedBuyer,
  checkTwoMarriedPeople,
  getBuyerFullName,
  getBuyerId,
  findSpouse,
  getRelationship,
  generateRelationshipModalProps,
  updateMaritalStatus,
  buildRelationshipsMap,
  SPOUSE_ON_CONTRACT_NA,
  SOMEONE_ELSE,
  transformerEntityApiToFe,
  transformerEntityFeToApi,
  transformerCobuyerApiToFe,
  transformerCobuyerFeToApi,
  TabsDeprecated,
  PaneDeprecated,
  createTrusteePurchaseProfile,
  updateTrusteePurchaseProfile,
  TrusteePurchaseProfileFormFields,
  TRUSTEE_PURCHASE_PROFILE_FORM_NAME,
  TRUSTEE_PURCHASE_PROFILE_FORM_FRAGMENT,
  SMSOptInToggle,
  MultiCoBuyerForm,
  MULTI_CO_BUYER_FORM_NAME,
  RelationshipModal,
  InternationalCheckbox,
  AdcHeader,
  LogoHeader,
  NativeAppBanner,
  CreditCard,
  PostSaveOptInModal,
  PhoneInputField,
  QRCode,
  OnboardingDrawer,
  PageWrapper,
  ChatButton,
  ChatLink,
  AdcSearch,
  NEW_ENTITY_FORM_NAME,
  MAX_AMOUNT_OF_ADDRESS_RESULTS,
  NewUserOnboardingModals,
  SearchLocationInterestReduxWrapper,
  BudgetDropdownReduxWrapper,
  CardTab,
  Bars,
  getMultiEntityFormFields,
  getMultiCobuyerFormFields,
  TutorialTooltipGroupItem,
  TutorialTooltipActions,
  TutorialTooltipReducer,
  TutorialTooltip,
  Footer,
  OfferBadge,
  OfferAmountHeader,
  OfferSummaryHeader,
  Gauge,
  ContractNotification,
  LogoutButton,
  ListingCarousel,
  ListingCarouselEmbedded,
  ListingCarouselEmbeddedProps,
  ListingInfoCard,
  ListingPhotoGrid,
  VerificationModal,
  AuctionApplication,
  FocusedAuctionApplication,
  ApplicationHeader,
  useApplicationContext,
  useApplicationModals,
  useApplicationQueues,
  useApplicationSurvey,
  withApplicationContext,
  ApplicationContext,
  ApplicationContextProvider,
  notifiers,
  withNotifications,
  StripePaymentSetup,
  AcceptBidContent,
  DeclineBidContent,
}
